import { useMemo, useState } from 'react'
import { useTable } from 'react-table'
import { CustomHeaderColumn } from './columns/CustomHeaderColumn'
import { CustomRow } from './columns/CustomRow'
import { returnColumns } from './columns/_columns'
import { useNavigate } from 'react-router-dom'
import { useIntl } from 'react-intl'
import { useAuth } from '../../../auth'
import { usePromotionsQueryResponse, usePromotionsQueryResponseData } from '../core/PromotionsResponseProvider'

const PromotionsTable = () => {
  const querylistings = usePromotionsQueryResponseData()
  const { query } = usePromotionsQueryResponse()

  const { getAllowedPermissionValue } = useAuth()
  const intl = useIntl()
  const users = querylistings
  const data = useMemo(() => users, [users])
  const navigate = useNavigate()
  const columns = useMemo(() => {
    return returnColumns(navigate)
    // eslint-disable-next-line
  }, [])
  const { getTableProps, getTableBodyProps, headers, rows, prepareRow } = useTable({
    columns,
    data,
  })
  const [loading, setLoading] = useState(false)

  return (
    <>
      <div className='table-responsive'>
        <table
          id='kt_table_users'
          className='table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer'
          {...getTableProps()}
        >
          <thead>
            <tr className='text-start align-baseline text-muted fw-bolder fs-7 text-uppercase gs-0'>
              {headers.map((column) => (
                <CustomHeaderColumn key={column.id} column={column} />
              ))}
            </tr>
          </thead>
          <tbody className='text-gray-600 fw-bold' {...getTableBodyProps()}>
            {rows.length > 0 ? (
              rows.map((row, i) => {
                prepareRow(row)
                return <CustomRow row={row} key={`row-${i}-${row.id}`} />
              })
            ) : (
              <tr>
                <td colSpan={7}>
                  <div className='d-flex text-center w-100 align-content-center justify-content-center'>
                    {intl.formatMessage({
                      id: 'RESULT.EMPTY',
                    })}
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </>
  )
}

export { PromotionsTable }
